import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import HospitalizationForm from './H';
import TPDForm from './TPD';
import PPDForm from './PPD';
import MPDForm from './MPD';
import TDForm from './TD';
import TACForm from './TAC';
import IUForm from './IU';
import Spacing from '../../../../components/layout/Spacing';
import Loader from '../../../../components/Loader/loader';
import { contextSelector } from '../../ActiveJourneyProvider/selectors';
import { refetchRiskContext } from '../../ActiveJourneyProvider/actions';
import { TEST_ATTR } from '../../../../constants';

const RiskDetailsForm = () => {
  const { isInitialized, riskType, riskDetailRefetching } =
    useSelector(contextSelector);
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!riskType) {
      if (state.riskType) dispatch(refetchRiskContext(state));
      else navigate('../risk-type');
    }
  }, []);

  if (!isInitialized || riskDetailRefetching)
    return (
      <Spacing>
        <Loader message="" />
      </Spacing>
    );

  return (
    <div {...{ [TEST_ATTR]: 'form-journey-risk_details' }}>
      {riskType === 'H' && <HospitalizationForm />}
      {riskType === 'TPD' && <TPDForm />}
      {riskType === 'PPD' && <PPDForm />}
      {riskType === 'MPD' && <MPDForm />}
      {riskType === 'TD' && <TDForm />}
      {riskType === 'IU' && <IUForm />}
      {riskType === 'TAC' && <TACForm />}
    </div>
  );
};

export default RiskDetailsForm;
